export default __webpack_public_path__ + "static/media/NepalCurrencyIcon.da66fbf7.svg";